module.exports = __webpack_public_path__ + "img/pay_bj.497484f5.png";